import { useEffect, useMemo, useRef, useState } from 'react'
import debounce from 'lodash.debounce'

export default function ColorPicker({ value, onChange }) {
  const [localColor, setLocalColor] = useState(value || '#000000')

  const onChangeRef = useRef(onChange)
  useEffect(() => {
    onChangeRef.current = onChange
  }, [onChange])

  const debouncedChange = useMemo(() => {
    const fn = debounce((color) => {
      onChangeRef.current?.(color)
    }, 300)
    return fn
  }, [])

  useEffect(() => {
    return () => debouncedChange.cancel()
  }, [debouncedChange])

  // Keep local state in sync if parent updates value
  useEffect(() => {
    if (value && value !== localColor) {
      setLocalColor(value)
    }
  }, [value])

  const handleInput = (e) => {
    const newColor = e.target.value
    setLocalColor(newColor)
    debouncedChange(newColor)
  }

  return (
    <div className="flex items-center gap-3">
      <input
        type="color"
        value={localColor}
        onChange={handleInput}
        onInput={handleInput}
        className="w-12 h-12 border rounded-md cursor-pointer"
      />
      <span className="text-sm text-gray-600">{localColor}</span>
    </div>
  )
}
